import React, { useContext } from 'react';
import { ShopContext } from "../Context/ShopContext";
import { useParams } from 'react-router-dom';

import Bredcrum from '../Components/Bredcrum/Bredcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';

const Product = () => {

  const { all_product } = useContext(ShopContext);
  const { productId } = useParams();

  const product = all_product.find(
    (e) => e.id === Number(productId)
  );

  if (!product) {
    return <h2>Product Not Found</h2>;
  }

  return (
    <div>
      <Bredcrum product={product} />

      <ProductDisplay product={product} />
       <DescriptionBox/>
      <RelatedProducts/>
    </div>
  );
};

export default Product;